import { portalInfoSchema, type PortalInfo } from '@growup/streaming-shared';
import { createContext, useContext, useEffect, useState, type ReactNode } from 'react';

const PortalContext = createContext<PortalInfo | null>(null);

/**
 * `GET /api/portal`, read once: where the main site is (accounts are created
 * and Twitch is linked there) and whether Twitch is configured.
 */
export function PortalProvider({ children }: { children: ReactNode }) {
  const [info, setInfo] = useState<PortalInfo | null>(null);
  useEffect(() => {
    fetch('/api/portal', { headers: { accept: 'application/json' } })
      .then(async (r) => (r.ok ? portalInfoSchema.parse(await r.json()) : null))
      .then(setInfo)
      .catch(() => setInfo(null));
  }, []);
  return <PortalContext.Provider value={info}>{children}</PortalContext.Provider>;
}

/** `null` until the API answered (or if it did not). */
export function usePortal(): PortalInfo | null {
  return useContext(PortalContext);
}

/** A page on the main site (`/conta/registar`), or `fallback` text when unknown. */
export function siteLink(info: PortalInfo | null, path: string): string | null {
  return info ? new URL(path, info.siteUrl).toString() : null;
}
